import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import OrderConfirmationMobile from './OrderConfirmationMobile';
import OrderConfirmationDesktop from './OrderConfirmationDesktop';
import Header from '../../Header';
import Footer from '../../Footer';
import { usePaymentSettings } from '../../../hooks/usePaymentSettings';

const OrderConfirmationPage = () => {
  const { uuid } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const {
    settings: paymentSettings,
    loading: settingsLoading,
  } = usePaymentSettings();

  useEffect(() => {
    window.scrollTo(0, 0);

    axios
      .get(`/api/v1/order/public-info/${uuid}`)
      .then(res => {
        setOrder(res.data);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [uuid]);

  if (loading || settingsLoading) {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col p-0'>
            <Header />
          </div>
        </div>
        <div className='container py-5 text-center'>
          Завантаження…
        </div>
        <div className='row'>
          <div className='col p-0'>
            <Footer />
          </div>
        </div>
      </div>
    );
  }

  /* ===== ERROR ===== */
  if (error || !order) {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col p-0'>
            <Header />
          </div>
        </div>
        <div className='container py-5 text-center'>
          <h5>Не вдалося знайти замовлення</h5>
          <Link to='/' className='btn btn-dark mt-3'>
            На головну
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  /* ===== SUCCESS ===== */
  return (
    <>
      <div className='container'>
        <div className='row'>
          <div className='col p-0'>
            <Header />
          </div>
        </div>


        {/* ===== MOBILE ===== */}
        <div className='row d-lg-none'>
          <div className='col p-0'>
            <OrderConfirmationMobile
              order={order}
              paymentSettings={paymentSettings}
            />
          </div>
        </div>

        {/* ===== DESKTOP ===== */}
        <div className='row d-none d-lg-block'>
          <div className='col p-0'>
            <OrderConfirmationDesktop
              order={order}
              paymentSettings={paymentSettings}
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OrderConfirmationPage;
